module.exports = __webpack_public_path__ + "img/address.c97abaef.png";